import { createActions } from 'reduxsauce';
import { IPageImageFilenames } from 'store/donatePage/types';

export interface ImpactReportState {
  data: ImpactReportData | null;
  isLoading: boolean;
  error: string | null;
  errorStatus: number | null;
}

export type ImpactReportData = {
  donation_amount_total: number;
  donation_amount_multiplier: number;
  donation_amount_total_adjusted: number;
  recipient_count: number;
  recipient_counts: object;
  recipient_count_federal: number;
  recipient_count_statewide: number;
  recipient_count_local: number;
  recipient_count_ballot_measures: number;
  recipient_count_organizations: number;
  recipient_count_stateleg: number;
  // null when the user has no races.
  recipient_impact_score_average: number | null;
  recipient_ids_winners: string[];
  election_margin_count_average: number;
  election_margin_percentage_average: number;
  election_margin_min: IElectionMargin;
  spam_avoided_count: number;
  top_issue_donation_percentage: number;
  issues: IIssue[];
  candidates: ICandidate[];
  race_ids: string[];
  race_ids_election_result_pending: string[];
  race_ids_result_not_certified: string[];
  video: string | null;
  video_duration_ms: number | null;
};

export interface IElectionMargin {
  count: number;
  percentage: string;
  election_id: string;
  recipient_name: string;
  election_name: string;
  election_result: string;
  impact_score: string;
}

export interface IIssue {
  id: number;
  page_name: string;
  query_string: string;
  donation_amount: string;
  image_filenames?: IPageImageFilenames;
}

export interface ICandidate {
  recipient_id: string;
  type: string;
  type_display: string;
  photo_id: string | null;
}

export interface ImpactReportTypes {
  IMPACT_REPORT: 'IMPACT_REPORT';
  IMPACT_REPORT_START: 'IMPACT_REPORT_START';
  IMPACT_REPORT_SUCCESS: 'IMPACT_REPORT_SUCCESS';
  IMPACT_REPORT_ERROR: 'IMPACT_REPORT_ERROR';
  IMPACT_REPORT_CLEAN_UP: 'IMPACT_REPORT_CLEAN_UP';
}

const { Types, Creators } = createActions<ImpactReportTypes>({
  impactReport: ['data'],
  impactReportStart: null,
  impactReportSuccess: ['data'],
  impactReportError: ['error', 'errorStatus'],
  impactReportCleanUp: null,
});

export { Types };

export default Creators;
